import React from "react";
import { resolveImage } from "../lib/api";

const iconFor = (voxel, key) => {
  if (!voxel) return null;
  if (key === "design") return voxel.icon_design;
  if (key === "interactive" || key === "creative_suite") return voxel.icon_interactive || voxel.icon_creative_suite;
  if (key === "ai_building") return voxel.icon_ai_building;
  if (key === "showcase") return voxel.icon_showcase;
  return null;
};

const Toolkit = ({ site }) => {
  const cards = site?.stack || [];
  const voxel = site?.voxel_assets || {};
  if (cards.length === 0) return null;

  return (
    <section
      id="toolkit"
      className="relative py-16 md:py-24 overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, var(--bg) 0%, color-mix(in oklab, var(--violet-soft) 45%, var(--bg)) 100%)",
      }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.24em] uppercase text-[color:var(--muted)]">
            Toolkit
          </div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-semibold leading-[1.05]">
            {site?.stack_heading || "My toolkit"}
          </h2>
          {site?.stack_subheading && (
            <p className="mt-4 max-w-2xl mx-auto text-[color:var(--ink-soft)]">
              {site.stack_subheading}
            </p>
          )}
        </div>

        <div data-testid="toolkit-cards" className="grid md:grid-cols-3 gap-5 md:gap-6">
          {cards.map((c, i) => {
            const icon = iconFor(voxel, c.icon_key);
            return (
              <div
                key={c.title + i}
                data-testid={`toolkit-card-${i}`}
                className="relative p-6 md:p-8 rounded-[24px] border border-[color:var(--card-border)] overflow-hidden shadow-sm transition-transform duration-300 hover:-translate-y-1.5"
                style={{
                  background:
                    "linear-gradient(180deg, color-mix(in oklab, var(--violet-soft) 65%, var(--card)) 0%, color-mix(in oklab, var(--violet-soft) 25%, var(--card)) 100%)",
                }}
              >
                {/* Purple accent bar */}
                <div className="absolute inset-x-0 top-0 h-1 bg-[color:var(--violet)]" />

                <div className="relative flex justify-center h-44 md:h-56">
                  {icon ? (
                    <img
                      src={resolveImage(icon)}
                      alt=""
                      className="h-full w-auto object-contain mk-drift"
                      style={{ animationDelay: `${i * 0.7}s` }}
                    />
                  ) : (
                    <div className="w-28 h-28 rounded-2xl bg-[color:var(--violet)] opacity-30" />
                  )}
                </div>
                <div className="mt-4 text-center">
                  <h3 className="font-display text-xl md:text-2xl font-semibold">{c.title}</h3>
                  {c.subtitle && (
                    <p className="mt-1 text-sm text-[color:var(--muted)]">{c.subtitle}</p>
                  )}
                </div>
                <ul className="mt-5 flex flex-wrap justify-center gap-2">
                  {(c.tools || []).map((t) => (
                    <li
                      key={t}
                      className="text-xs md:text-sm px-3 py-1.5 rounded-full bg-[color:var(--card)]/70 border border-[color:var(--card-border)] text-[color:var(--ink-soft)]"
                    >
                      {t}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Toolkit;
